<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img src="images/fgk-product.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>
						太保高空行业雇主险-
						<span style="color: red">低伤残低价版</span>
					</h2>
					<div>行业超低价 | 中国太平洋承保 | 全线上操作</div>
					<p>
						① 覆盖行业广，涉电涉高均可保
						<br />
						② 保额最高120万，社保用药、误工费有保障
						<br />
						③ 3人起保，无安全带/无特种证不拒赔
					</p>
					<div>
						<el-button size="medium" type="warning" @click.native="handleInsure(0)">立即投保</el-button>
						<el-button size="medium" type="primary" @click.native="handleInsure(1)">投保计划书</el-button>
					</div>
					<br />
					<el-button
						:loading="isDownLoading"
						icon="el-icon-download"
						size="medium"
						style="margin-top: 5px"
						type="text"
						@click.native="handleDownLoad">
						下载太保职业类别表
					</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<template slot="header">
						<el-alert
							:closable="false"
							show-icon
							title="【特别提醒】本方案保障的其他6类不包括钢结构、钢骨结构、机械设备拆除工"
							type="warning"></el-alert>
						<el-alert
							:closable="false"
							show-icon
							style="margin-top: 10px"
							title="营业执照地址为浙江、安徽、辽宁、重庆、河北地区的企业，方案请选择地区版。"
							type="warning"></el-alert>
						<div style="margin-top: 10px; margin-bottom: 10px">年单（针对2022年9月1日之前已投保且无出险老客户）</div>
						方案：
						<el-select v-model="planType" placeholder="请选择方案">
							<el-option
								v-for="item in planTypeOption"
								:key="item.value"
								:label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</template>
					<avue-crud ref="plan" :data="dataPlan" :option="optionPlan" :span-method="spanMethodPlan"></avue-crud>
				</el-card>
				<el-card header="批增规则">
					<avue-crud ref="add" :data="dataAddFeeRate" :option="optionAddFeeRate"></avue-crud>
					<!--          <avue-crud ref="premium"-->
					<!--                     :data="dataPremium"-->
					<!--                     :option="optionPremium"-->
					<!--                     :span-method="spanMethodPremium">-->
					<!--          </avue-crud>-->
				</el-card>
				<el-card header="赔付标准">
					<el-row justify="center" type="flex">
						<span style="font-weight: 500; color: Red; margin-bottom: 20px">
							社保用药范围100%赔付，伤残等级对应赔付比例请查看附表
						</span>
					</el-row>
					<avue-crud ref="crud" :data="dataBenefit" :option="optionBenefit">
						<template slot="header"></template>
					</avue-crud>
				</el-card>
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="20">
						<ul>
							<li v-for="qa in dataQA" :key="qa.question">
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ qa.question }}</span>
								</div>
								<p></p>
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>
									<span>{{ qa.answer }}</span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="20">
						<h3>保险条款及须知</h3>
						<p style="line-height: 32px">
							1、 本保险适用以下保险条款
							<br />
							<span class="link">
								<a href="fgkclause.html" style="color: DodgerBlue" target="_blank">
									中国太平洋财产保险股份有限公司雇主责任保险条款
								</a>
							</span>
							2、本保险由中国太平洋财产保险股份有限公司承保，承保区域为全国范围（港澳台除外）。
							<br />
							3、保险公司设有省级分支机构和落地服务机构的省清单见如下链接：
							<br />
							<span class="link">
								<a
									href="http://property.cpic.com.cn/xccbx/gygs/fzjg/index.shtml?skip="
									style="color: DodgerBlue"
									target="_blank">
									省级分支机构和落地服务机构
								</a>
							</span>
							4、保险公司全国统一的客户服务及投诉方式详见如下链接：
							<br />
							<span class="link">
								<a
									href="http://property.cpic.com.cn/xccbx/gkxxbl/jbxx/gsgk/?subMenu=1&amp;inSub=1"
									style="color: DodgerBlue"
									target="_blank">
									全国统一的客户服务及投诉方式
								</a>
							</span>
							5、在投保本保险前请您认真阅读《
							<span class="red-bold">雇主责任</span>
							保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款（包括但不限于责任免除、
							<span class="red-bold">免赔额</span>
							、投保人被保险人义务等）。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。
							<br />
							<span class="red-bold"></span>
							6、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，
							<span class="red-bold">但</span>
							退还保险费。
							<br />
							7、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。
							<br />
							8、
							<span class="red-bold">本保险提供电子发票。</span>
							<br />
							9、
							<span class="red-bold">
								本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。
							</span>
							<br />
							10、
							<span class="red-bold">保单未到期前，</span>
							如被保险人未有员工出险，则保险人收取
							<span class="red-bold">保单约定</span>
							最低保费后，允许保单退保，并退还
							<span class="red-bold">未满期净保费</span>
							。最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
							<br />
						</p>
						<el-divider></el-divider>
						<h3>特别约定</h3>
						<p style="line-height: 32px; white-space: pre-line">
							1、
							<span class="red-bold">
								被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔50%后赔付。
							</span>
							如果事故实际发生日期早于本保单生效日期，但被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
							2、出险后，被保险人必须在72小时内通过微信小程序“线上快赔”上传出险照片报案，报案服务咨询可拨打400-180-1616或太平洋产险全国统一客服电话95500，取得报案号后才是报案成功（否则报案失败）。
							<span class="red-bold">
								如果被保险人委托第三人/第三方报案，事后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第1条特别约定扣除免赔，那么被保险人须自行承担相关损失。
							</span>
							3、
							<span class="red-bold">被保险人雇员的年龄限16-65周岁（含），本方案每人限投1份，超过部分无效。</span>
							被保险人雇员由于工作原因受到伤害，依照《工伤保险条例》及相关法律应当认定为工伤或视同工伤的，对于被保险人依法应承担的经济赔偿责任，保险人在本保单的责任限额内予以赔付。
							<span class="red-bold">本保单不承保承揽关系。</span>
							4、
							<span class="red-bold">
								本保单可加人（保险期限不足1个月的按1个月收费），不可减人。保险期限1-3个月（含）的保单不可换人，
							</span>
							保险期限超过3个月的保单可以换人，
							<span class="red-bold">任何保险期限的已出险人员不可替换。</span>
							换人规则：原4-5类工种人员可替换为新的4-5类工种人员，原6类工种人员可替换为新的6类工种人员，4-5类工种人员和6类工种人员之间不可互换。
							5、
							<span class="red-bold">
								保单未到期前，如被保险人未有员工出险，则保险人收取保单约定最低保费后，允许保单退保，并退还未满期净保费。
							</span>
							最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
							6、本保单可承保4-6类工种(含高处作业）：电梯/升降梯安装维修、通信工程安装及维护（不含铁塔架设和拆除）、焊工、电力建设及检修、广告牌安装及维修及路灯安装、外墙清洗、玻璃幕墙安装及维修、建筑工程（仅限工业、民用建房工程以及装修）等。本产品可承保工种以太保职业分类表为准，本保单雇员投保的工种以保单的雇员清单为准。
							7、
							<span class="red-bold">
								本保单不承保工种：水下作业工种、地下作业工种、海上作业工种（渔业、油矿开采等）、矿业/采石业工种、森林防火员、体育运动工种、影视及演艺业工种、战地记者、驯兽师、钢丝绳生产加工、塔吊安装/拆除/维修的工种、铁塔架设/拆除的工种、窑炉/烟囱/高炉新建和拆除的工种、金属冶炼、钢缆生产加工工种、船舶制造/维修/拆除的工种、化工/军工相关工作工种、涉及火药/炸药/爆破的相关工作工种、保安/保镖/特种兵/军人/武警/公安/警察/消防等治安人员、管道（水下或深度超过1米的地下）/公路/山路/铁路/桥梁/水利/隧道/建筑拆除的工种、钢结构安装或拆除的工种、机械设备拆除工。如施工合同中的项目名称或者作业内容含有保险人不承保的工种字眼，如“桥梁”等，保险人不承担任何赔偿责任。
							</span>
							8、建筑拆除（含钢结构）是指对已经建成或部分建成的建筑物或构筑物等进行拆除的工程作业。屋面防水、屋面防腐、屋面翻新维修、屋面更换均不属于建筑拆除范畴。
							9、
							<span class="red-bold">
								被保险人雇员遭受伤害时，实际从事的工作（不属于拒绝承保工种）危险程度高于投保人明确告知保险人的工作类型的，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔20%后赔付。如属于第7条特约的不承保工种，保险人不承担任何赔偿责任。
							</span>
							10、
							<span class="red-bold">在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡</span>
							（雇员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），保险人承担赔偿责任，赔付金额=每人身故赔偿限额*20%。
							11、
							<span class="red-bold">
								在本保单有效期内，被保险人雇员在从事与本保单所载明的被保险人的业务工作而罹患与业务有关的国家规定的职业性疾病的，须提供县级以上医院或疾控中心出具的相关确诊证明。确诊证明资料载明职业病罹患时间在本保单保险责任起始日期之前的，保险人不承担任何赔偿责任。
							</span>
							12、如被保险人雇员遭遇保险事故导致身故，保险人按工伤赔偿标准核算身故赔偿金。
							13、如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=每人伤残赔偿限额*伤残等级对应的赔付比例。
							14、按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，
							<span class="red-bold">
								六级伤残给付比例40%，七级伤残给付比例30%，八级伤残给付比例10%，九级伤残给付比例7%，十级伤残给付比例5%。
							</span>
							15、医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。
							16、误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。
							<span class="red-bold">
								按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算仅依据住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且自伤残鉴定日期起停止误工费的计算。被保险人雇员仅接受门诊治疗的，无误工费赔付。
							</span>
							17、
							<span class="red-bold">本保单不承担任何性质的精神损害赔偿责任。</span>
							18、
							<span class="red-bold">
								从事高处作业必须佩戴安全带，从事特种作业必须取得对应有效特种作业操作证（包括但不限于高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，扣除绝对免赔25%后赔付。
							</span>
							高处作业证及其他特种作业操作证必须由应急管理部门颁发。 19、
							<span class="red-bold">
								本保单指定就诊医院为大陆境内二级及以上公立医院，但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、霸州市、秦皇岛青龙县；湖北黄冈市、麻城市、武穴市、荆州市。如因危及生命的紧急抢救（达到住院标准）无法前往本保单指定就诊医院的，经急救、情况基本稳定后72小时内，须转入本保单指定就诊医院治疗。
							</span>
							20、
							<span class="red-bold">
								在上下班途中，受到非员工本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。
							</span>
							21、以下情形，保险人不得以保单上列明工种有误而拒赔或者减少承担赔偿责任：保单上列明工种对应的保费，不低于被保险人实际工种对应的保费。
							22、
							<span class="red-bold">
								兹经双方同意，本保单累计赔偿限额为1000万，每次事故赔偿限额为500万。若伤亡事故造成的实际损失超出赔偿限额，对于超出部分，保险人不承担任何赔偿责任。
							</span>
							23、
							<span class="red-bold">
								如被保险人投保了工伤保险，则由工伤保险先行赔付，本保险再赔付差额部分；而投保了其他商业保险，则依照保险法的重复保险要求，其他商业保险与本保险按比例承担赔偿保险金的责任。
							</span>
							24、
							<span class="red-bold">兹经双方确认，因保险合同纠纷提起的诉讼，由被告住所地的人民法院管辖。</span>
							25、
							<span class="red-bold">
								如您不幸发生事故，或需要咨询保险相关事宜，请及时拨打服务热线：400-180-1616，获取工作人员的帮助。
							</span>
							26、
							<span class="red-bold">太平洋产险全国统一客户投诉电话：95500语音提示或按＃号键-3-2-4</span>
						</p>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {getProductPrice} from '@/api/insurance/product'
import {handleDownCategoryFile} from '@/util/util'
import {currentYYYYmmdd} from '@/util/date'
import {
	optionAddFeeRate,
	optionBenefit,
	optionPlan,
	optionPremium,
	optionPremiumRestrict,
} from '@/const/crud/insurance/productDetail'

export default {
	name: 'Product45Details',
	props: {
		productId: {
			type: String | Number,
			required: true,
		},
	},
	data: function () {
		return {
			currentStep: '0',
			optionPlan: optionPlan,
			optionPremium: optionPremium,
			optionPremiumRestrict: optionPremiumRestrict,
			optionBenefit: optionBenefit,
			optionAddFeeRate: optionAddFeeRate,
			dataPlan: [
				{
					insuredItem: '身故/伤残',
					plan1: '30万',
					plan2: '50万',
					plan3: '80万',
					plan4: '100万',
					plan5: '120万',
				},
				{
					insuredItem: '医疗费用|限社保用药',
					plan1: '3万',
					plan2: '5万',
					plan3: '8万',
					plan4: '10万',
					plan5: '20万',
				},
				{
					insuredItem: '误工费用',
					plan1: '100元/天/上限180天 | 每次90天',
				},
				{
					insuredItem: '法律费用',
					plan1: '10万',
				},
				{
					insuredItem: '医疗费用赔付',
					plan1: '社保用药100%赔付',
				},
				// {
				//   insuredItem: '6类职业（不含钢结构、钢骨结构、机械设备拆除工）投保收费'
				// },
				// {
				//   insuredItem: '短期单批增收费'
				// },{
				//   insuredItem: '4-5类职业投保收费'
				// },{
				//   insuredItem: '短期单批增收费'
				// },

				// {
				//   insuredItem: '年保费'
				// },
				// {
				//   insuredItem: '4-5类职业',
				//   scope: 9
				// },
				// {
				//   insuredItem: '其他6类职业',
				//   scope: 10
				// }
			],
			//
			//3个月	300	450	750	840	1125
			//6个月	600	900	1500	1680	2250
			//年单	840	1200	2040	2160	3000

			sixLei: [
				[
					'1个月',
					'105',
					'150',
					'255',
					'280',
					'375',
					'3个月',
					'300',
					'450',
					'750',
					'840',
					'1125',
					'6个月',
					'600',
					'900',
					'1500',
					'1680',
					'2250',
					'年单',
					'840',
					'1200',
					'2040',
					'2160',
					'3000',
				],
				[
					'1个月',
					116,
					165,
					281,
					297,
					400,
					' 3个月',
					347,
					495,
					842,
					891,
					1200,
					'6个月',
					693,
					990,
					1683,
					1782,
					2400,
					'年单',
					'不销售',
					'不销售',
					'不销售',
					'不销售',
					'不销售',
				],
			],
			sixLeiPi: [
				[
					'2个月',
					'210',
					'300',
					'510',
					'540',
					'750',
					'4个月',
					'420',
					'600',
					'1020',
					'1080',
					'1500',
					'5个月',
					'525',
					'750',
					'1275',
					'1350',
					'1875',
				],
				['2个月', 231, 330, 561, 594, 800, '4个月', 462, 660, 1122, 1188, 1600, '5个月', 578, 825, 1403, 1485, 2000],
			],

			forLei: [
				[
					'1个月',
					'90',
					'135',
					'195',
					'225',
					'285',
					'3个月',
					'180',
					'270',
					'390',
					'450',
					'570',
					'6个月',
					'360',
					'540',
					'780',
					'900',
					'1140',
					'年单',
					'600',
					'900',
					'1300',
					'1500',
					'1900',
				],
				[
					'1个月',
					99,
					149,
					215,
					248,
					314,
					'3个月',
					198,
					297,
					429,
					495,
					627,
					'6个月',
					396,
					594,
					858,
					990,
					1254,
					'年单',
					660,
					990,
					1430,
					1650,
					2090,
				],
			],
			forLeiP1: [
				[
					'2个月',
					'120',
					'180',
					'260',
					'300',
					'380',
					'4个月',
					'240',
					'360',
					'520',
					'600',
					'760',
					'5个月',
					'300',
					'450',
					'650',
					'750',
					'950',
				],
				['2个月', 132, 198, 286, 330, 418, '4个月', 264, 396, 572, 660, 836, '5个月', 330, 495, 715, 825, 1045],
			],

			coverageMap: new Map([
				[30, 1],
				[50, 2],
				[80, 3],
				[100, 4],
				[120, 5],
			]),
			dataBenefit: [
				{
					levelItem: '比例',
					level10: '5%',
					level9: '7%',
					level8: '10%',
					level7: '30%',
					level6: '40%',
					level5: '60%',
					level4: '70%',
					level3: '80%',
					level2: '90%',
					level1: '100%',
				},
			],
			dataAddFeeRate: [
				{
					category: '4-5类',
					scope: 9,
				},
				{
					category: '其他6类',
					scope: 10,
				},
			],
			dataPremium: [
				{
					insuredTerm: '投保收费规则',
				},
				{
					insuredTerm: '1个月',
					term: 1,
				},
				{
					insuredTerm: '3个月',
					term: 3,
				},
				{
					insuredTerm: '6个月',
					term: 6,
				},
				{
					insuredTerm: '批增收费规则',
				},
				{
					insuredTerm: '2个月',
					term: 2,
				},
				{
					insuredTerm: '4个月',
					term: 4,
				},
				{
					insuredTerm: '5个月',
					term: 5,
				},
			],
			dataPremiumRestrict: [
				{
					insuredTerm: '投保收费规则',
				},
				{
					insuredTerm: '1个月',
					term: 1,
				},
				{
					insuredTerm: '3个月',
					term: 3,
				},
				{
					insuredTerm: '6个月',
					term: 6,
				},
				{
					insuredTerm: '批增收费规则',
				},
				{
					insuredTerm: '2个月',
					term: 2,
				},
				{
					insuredTerm: '4个月',
					term: 4,
				},
				{
					insuredTerm: '5个月',
					term: 5,
				},
			],
			dataQA: [
				{
					question: '本产品的保险公司是哪家？',
					answer: '本产品由世界500强的中国太平洋财产保险股份有限公司承保。',
				},
				{
					question: '雇员的年龄有限制吗，保险责任是哪些？',
					answer:
						'保险人雇员的年龄限16-65周岁（不超65），本方案每人限投1份，超过部分无效。被保险人雇员由于工作原因受到伤害，依照《工伤保险条例》及相关法律应当认定为工伤或视同工伤的，对于被保险人依法应承担的经济赔偿责任，保险人在本保单的责任限额内予以赔付。',
				},
				{
					question: '哪些职业可保？',
					answer:
						'本产品可保障职业：电梯/升降梯安装维修、通信工程安装及维护（不含铁塔架设和拆除）、焊工、电力建设及检修、广告牌安装及维修及路灯安装、外墙清洗、玻璃幕墙安装及维修、建筑工程（仅限工业、民用建房工程以及装修）等。',
				},
				{
					question: '哪些职业不保？',
					answer:
						'本保单不承保职业：水下作业、地下作业、海上作业（渔业、油矿开采等）、矿业/采石业、森林防火员、体育运动、影视及演艺业、战地记者、驯兽师、钢丝绳生产加工、塔吊安装拆除和维修、铁塔架设和拆除、窑炉/烟囱新建和拆除、高炉相关工作、金属冶炼、钢缆生产加工、船舶/化工/军工相关工作、涉及火药/炸药/爆破的相关工作、保安/保镖、特种兵/军人/武警/公安/警察/消防等治安人员、管道（水下或深度超过1米的地下）/公路/山路/铁路/桥梁/水利/隧道工程、建筑拆除。如施工合同中的项目名称或者作业内容含有保险人不承保的职业类别，如“桥梁”等等，保险人不承担任何赔偿责任。',
				},
				{
					question: '如果从事高处作业，但是无安全带或者无特种作业操作证（比如高处作业证），保险公司是否拒赔？',
					answer:
						'不会拒赔。被保险人雇员无安全带或者无特种作业操作证（包括但不限高处作业证），保险人承诺不拒赔；从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，免赔25%。',
				},
				{
					question: '什么是高处作业？',
					answer:
						'国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。”',
				},
				{
					question: '误工费怎么赔？',
					answer:
						'按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。被保险人雇员仅接受门诊治疗的，按本保单约定无误工费赔付。',
				},
				{
					question: '本方案保障期限是多久？',
					answer: '目前仅支持投保1个月、3个月和6个月，可进行人员批增。',
				},
				{
					question: '本方案如何收费？',
					answer: '请打开“保险详情”页查看收费规则。',
				},
				{
					question: '怎么投保？怎么支付？',
					answer:
						'直接用电脑在此网页上操作即可，无需任何纸质资料，具体流程：选方案→填信息→支付保费→获取保单。目前支持微信、支付宝、银联支付。',
				},
				{
					question: '保单和发票怎么获取？',
					answer: '线上投保完成后实时出具电子保单，如果客户选择普票则实时出具电子普票，如果选择专票则通过快递寄送。',
				},
				{
					question: '保单如何查验真伪？',
					answer: '可以通过拨打太平洋保险全国客服电话95500进行人工查询。',
				},
				{
					question: '雇员变动怎么办？',
					answer:
						'本产品可加人（不足1个月的按1个月收费），不可减人。保险期限1-3个月的保单不可换人，保险期限超过3个月的保单可以换人。替换时，原4-5类职业人员只能替换为新的4-5类职业人员，原6类职业人员只能替换为新的6类职业人员。不分节假日，全天24小时，均可线上直接替换或新增人员。',
				},
				{
					question: '出险员工是否可替换出去？',
					answer: '不可以。',
				},
				{
					question: '怎么理赔？多久收到赔款？',
					answer:
						'出险后请拨打理赔专线400-180-1616报案→收集资料→提交审核→支付结案。理赔时效：万元以下资料齐全，1个工作日赔款到账；万元以上资料齐全，在保险双方达成一致意见后一般十个工作日赔款到账。',
				},
				{
					question: '是否可保承揽关系，什么是承揽关系？',
					answer:
						'本保单不承保承揽关系。根据《中华人民共和国民法典》规定：承揽人按照定作人的要求完成工作，交付劳动成果，定作人给付报酬的权利义务关系，承揽人应当以自己的设备、技术和劳力完成主要工作，但当事人另有约定的除外。',
				},
			],
			isDownLoading: false,
			planType: 0,
			planTypeOption: [
				{
					value: 0,
					label: '全国版',
				},
				{
					value: 1,
					label: '地区版',
				},
			],
		}
	},
	created() {
		this.init()
	},
	watch: {
		planType: {
			handler(newVal, oldVal) {
				this.onDealData(newVal)
			},
			immediate: true,
		},
	},
	methods: {
		init() {
			let query = {
				pid: this.productId,
			}
			getProductPrice(query).then(({data: {data = [], code = -1}}) => {
				if (code !== 0 || data.length === 0) {
					this.$message.error('获取数据有误!')
					return
				}
				data.forEach((item) => {
					let config = JSON.parse(item.config.replace('\n', ''))
					if (this.validatenull(item.rules)) {
						// this.setPlanData(item.coverage, item.scope, item.shortFeeMaps)
						this.setAddFeeRate(item.scope, config.operateConfig.add.yearFeeRate)
						// this.setPremiumData(item.coverage, item.scope, config.operateConfig.add.shortFee)
					} else {
						this.setPremiumRestrictData(item.coverage, config.operateConfig.add.shortFee)
					}
				})
			})
		},
		setAddFeeRate(scope, yearFees) {
			if (this.validatenull(yearFees)) {
				return
			}
			this.dataAddFeeRate.forEach((item) => {
				if (!this.validatenull(item.scope) && item.scope == scope) {
					for (var i = 1; i < 12; i++) {
						let prop = 'month' + i
						this.$set(item, prop, yearFees[i] + '%')
					}
				}
			})
		},
		setPlanData(coverage, scope, feeMap) {
			this.dataPlan.forEach((item) => {
				if (!this.validatenull(item.scope) && item.scope == scope) {
					let prop = 'plan' + this.coverageMap.get(coverage)
					let fee = feeMap[12]
					let value = !this.validatenull(fee) ? Math.round(fee / 100) + '元/年' : '不销售'
					this.$set(item, prop, value)
				}
			})
		},
		setPremiumData(coverage, scope, shortFee) {
			this.dataPremium.forEach((item) => {
				if (!this.validatenull(item.term)) {
					let prop = 'plan' + coverage + '_' + (scope - 8)
					let result = Math.round(shortFee[item.term] / 100)
					if (coverage === 120 && scope === 10) {
						result = '不销售'
					}
					this.$set(item, prop, result)
				}
			})
		},
		setPremiumRestrictData(coverage, shortFee) {
			this.dataPremiumRestrict.forEach((item) => {
				if (!this.validatenull(item.term)) {
					let prop = 'plan' + coverage
					this.$set(item, prop, Math.round(shortFee[item.term] / 100))
				}
			})
		},
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 2 || rowIndex === 3 || rowIndex === 4) {
				if (columnIndex === 1) {
					return [1, 6]
				}
			}

			if (rowIndex === 5 || rowIndex === 10 || rowIndex === 14 || rowIndex === 19) {
				if (columnIndex === 0) {
					return [1, 11]
				}
			}
		},
		spanMethodPremium({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 0 || rowIndex === 4) {
				if (columnIndex === 0) {
					return [1, 11]
				}
			}
		},
		spanMethodPremiumRestrict({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 0 || rowIndex === 4) {
				if (columnIndex === 0) {
					return [1, 6]
				}
			}
		},
		handleInsure(type) {
			this.$emit('insure', type)
		},
		handleDownLoad() {
			this.isDownLoading = true
			let fileName = `fgk_${this.productId}_template_chinalife_${currentYYYYmmdd()}.xlsx`
			handleDownCategoryFile(
				`/dist/distInsure/categoryDownloadDetail
/${this.productId}`,
				{},
				fileName,
			)
				.then(() => {
					//下载成功
				})
				.finally(() => {
					this.isDownLoading = false
				})
		},
		//处理数据
		onDealData(newVal) {
			let data1 = this.onGetItemData(this.sixLei[newVal], '6类职业（不含钢结构、钢骨结构、机械设备拆除工）投保收费')
			let data2 = this.onGetItemData(this.sixLeiPi[newVal], '短期单批增收费')
			let data3 = this.onGetItemData(this.forLei[newVal], '4-5类职业投保收费')
			let data4 = this.onGetItemData(this.forLeiP1[newVal], '短期单批增收费')

			console.log(this.dataPlan.length)
			if (this.dataPlan.length === 23) {
				this.dataPlan.splice(5, 18)
			}
			this.dataPlan = this.dataPlan.concat(data1).concat(data2).concat(data3).concat(data4)
		},
		onGetItemData(tempData, content) {
			let tempAllData = [
				{
					insuredItem: content,
				},
			]
			let tempItemData = {}
			tempData.forEach((itemData, index) => {
				let num = index % 6
				if (num === 0) {
					tempItemData = {
						insuredItem: itemData,
						plan1: '',
						plan2: '',
						plan3: '',
						plan4: '',
						plan5: '',
					}
				} else {
					tempItemData[`plan${index % 6}`] = itemData
					if (num === 5) {
						tempAllData.push(tempItemData)
					}
				}
			})
			return tempAllData
		},
	},
}
</script>

<style lang="scss" scoped>
.red-bold {
	font-weight: bold;
	color: red;
}

.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}

h2 {
	margin: 0px;
	padding: 0px;
}
</style>
